// helpers
import { formatDistanceToNow } from 'date-fns'
import dayjs from 'dayjs'
import isEmpty from 'lodash/isEmpty'
import { es } from 'date-fns/locale'

const AgoDateCell: React.FC = (rawDate: string, record) => {
  const { key, ...rest } = record
  let date = ''

  if (isEmpty(rest)) return null

  if (!rawDate) date = 'N/A'
  else date = formatDistanceToNow(dayjs(rawDate).locale('es').toDate(), { locale: es })


  const style = { display: 'flex', alignItems: 'center', justifyContent: 'start' }
  const props = {
    container: {
      style,
    }
  }

  return (
    <div {...props.container}>
      <div style={style}>
        {date}
      </div>
    </div>
  )
}

export default AgoDateCell
